import { useState } from 'react';
import { useInstallPrompt, promptInstall } from '../installPrompt';
import styles from './InstallBanner.module.css';

const DISMISS_KEY = 'mc_install_hint_dismissed';

/**
 * Quiet, dismissible hint nudging install on devices where it's possible.
 * Shows only for the `installable` / `ios-manual` states, and only until the
 * user dismisses it (persisted per-browser). Standalone / unsupported never
 * see it. This is a hint, not an alert — hence role="status" and the muted
 * accent styling.
 */
export function InstallBanner() {
  const install = useInstallPrompt();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === 'true',
  );

  if (dismissed) return null;
  if (install !== 'installable' && install !== 'ios-manual') return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  const handleInstall = () => {
    void promptInstall().finally(dismiss);
  };

  return (
    <div className={styles.banner} role="status">
      <span className={styles.label}>
        {install === 'installable'
          ? 'Install Markcat on this device for quick access.'
          // Directs to Safari because 'ios-manual' covers every iOS browser,
          // and only Safari's Share sheet offers Add to Home Screen.
          : 'Add Markcat to your Home Screen: open in Safari, tap Share → Add to Home Screen.'}
      </span>
      {install === 'installable' && (
        <button type="button" className={styles.button} onClick={handleInstall}>
          Install
        </button>
      )}
      <button
        type="button"
        className={styles.dismiss}
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
